export const generateCopyright = () => `© FundRE ${new Date().getFullYear()}`;
